import React from 'react';
import { IonSearchbar } from '@ionic/react';

export interface ProListToolbarProps {
  value: string;
  placeholder: string;
  onSearchChange: (value: string) => void;
  debounce?: number;
  /** Filter chips or other controls rendered below the search bar. */
  children?: React.ReactNode;
  className?: string;
}

/**
 * Shared search + filter strip for Pro list screens (Bills, Legislators, …).
 * Sits flush under the pinned purple IonHeader — flat, no nested elevation.
 */
const ProListToolbar: React.FC<ProListToolbarProps> = ({
  value,
  placeholder,
  onSearchChange,
  debounce = 300,
  children,
  className = '',
}) => (
  <div className={`pro-list-toolbar max-w-3xl mx-auto ${className}`.trim()}>
    <div className="px-2 pb-1">
      <IonSearchbar
        mode="md"
        value={value}
        debounce={debounce}
        onIonInput={(e) => onSearchChange(e.detail.value ?? '')}
        placeholder={placeholder}
        className="pro-list-searchbar text-sm"
      />
    </div>
    {children}
  </div>
);

export default ProListToolbar;
